import { call, put, takeEvery } from 'redux-saga/effects';
import { dashboardApi } from '../../api/dashboardApi';
import { getOemPartnerNamesApi } from '../../api/oemApi';
import {
  FETCH_DASHBOARD_DATA_REQUEST,
  FETCH_OEM_PARTNERS_REQUEST
} from '../constants/dashboardConstants';
import {
  fetchDashboardDataSuccess,
  fetchDashboardDataFailure,
  fetchOemPartnersSuccess,
  fetchOemPartnersFailure
} from '../actions/dashboardActions';

function* fetchDashboardDataSaga(action) {
  try {
    const { almataId, oemId } = action.payload;
    const response = yield call(dashboardApi.getDashboardData, almataId, oemId);
    yield put(fetchDashboardDataSuccess(response.data));
  } catch (error) {
    yield put(fetchDashboardDataFailure(error.response?.data?.message || error.message));
  }
}

function* fetchOemPartnersSaga(action) {
  try {
    const almataId = action.payload;
    const response = yield call(getOemPartnerNamesApi, almataId);
    yield put(fetchOemPartnersSuccess(response));
  } catch (error) {
    yield put(fetchOemPartnersFailure(error.response?.data?.message || error.message));
  }
}

export default function* dashboardSaga() {
  yield takeEvery(FETCH_DASHBOARD_DATA_REQUEST, fetchDashboardDataSaga);
  yield takeEvery(FETCH_OEM_PARTNERS_REQUEST, fetchOemPartnersSaga);
}